import styled from "styled-components";
import PropTypes from "prop-types";
import React from "react";
import { Theme } from "../../constants";
import { PageContextUtils } from "../../utils";

const SkeletonEl = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  margin: ${props => props.margin || "0 0 1.8rem 0"};
  background: ${props => {
    const themeOptions = {
      [Theme.Default]: `linear-gradient(
        90deg,
        rgb(55, 55, 55) 25%,
        rgb(35, 35, 35) 50%,
        rgb(55, 55, 55) 75%
      )`,
      [Theme.MrGreen]: `linear-gradient(
          90deg,
          rgb(21, 105, 74) 25%,
          rgb(1, 85, 54) 50%,
          rgb(21, 105, 74) 75%
      )`
    };
    return themeOptions[props.themeName] || "unset";
  }};
  background-size: 200% 100%;
  animation: loading 3s infinite;
  border-radius: 4px;

  &:last-child {
    margin-bottom: 0;
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const SkeletonElement = props => {
  const { height, width, margin = null } = props;
  const { currentName = Theme.Default } = PageContextUtils.getThemeData();

  return (
    <SkeletonEl
      themeName={currentName}
      height={height}
      width={width}
      margin={margin}
    />
  );
};

SkeletonElement.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  margin: PropTypes.string
};

export default SkeletonElement;
